import { Verticals } from '../../../../constants/verticals';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Autocomplete, TextField, Typography, IconButton, FormLabel, FormControl, ButtonGroup, Slider } from '@mui/material';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../../../actions/user.actions';
import CustomTextField from '../../../TextField/TextField';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import './BasicLoanForm.css';
import { tenureOptions, subVerticals, propertyTypeOptions, vehicleTypeOptions, statesList, PersonalLoanPurpose, tenureYearMonthOptions, businessTypeEntityTypes, turnoverRanges, businessLoanTenureMonthOptions } from '../../../../data';
import { fileCardTypes, mlFileCardTypes, newblFileCardTypes } from '../../../../utils/fileCardTypes.js';
import getAge from '../../../../utils/getAge.js';
import InputFileUpload from '../Fileupload/FileUpload';
import CustomAutoComplete from '../../../AutoComplete/AutoComplete';
import DeleteIcon from '@mui/icons-material/Delete';
import { Checkbox } from '@mui/material';
import axiosInstance from '../../../../helpers/axios';
import moment from 'moment';
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import OtpConsent from '../../../Consent/OtpConsent/OtpConsent';
import OCRFileUpload from '../OcrFileUpload/OCRFileUpload';
import OCRLoadingModal from '../OcrFileUpload/OCRLoadingModal';
import { useCurrentUser } from '../../../../hooks/useCurrentUser';
import Toast from '../../../Eligibility/Toast';

export default function BasicLoanForm({ loanType }) {
  const dispatch = useDispatch()
  const decode = useCurrentUser();
  const user = null;
  const [employment, setEmployment] = useState('EMPLOYED')
  const [uploadedFile, setUploadedFile] = useState(null)
  const [documentType, setDocumentType] = useState(null)
  const [filePassword, setFilePassword] = useState()
  const [instituteName, setInistuteName] = useState('')
  const [instituteList, setInstituteList] = useState([])
  const [startingPhrase, setStarterPhrase] = useState("Type Institute Name")
  const [studentFirstName, setStudentFirstName] = useState(null)
  const [studentLastName, setStudentLastName] = useState(null)
  const [studentEmail, setStudentEmail] = useState(null)
  const [studentPhone, setStudentPhone] = useState(null)
  const [courseName, setCourseName] = useState(null)
  const [courseFees, setCourseFees] = useState(null)
  const [tenure, setLoanTenure] = useState(null)
  const [tenureYears, setTenureYears] = useState(null)
  const [tenureMonths, setTenureMonths] = useState(null)
  const [partnerId, setPartnerId] = useState(null)
  const [partnerName, setPartnerName] = useState(null)
  const [defaultPartner, setDefaultPartner] = useState(null)
  const [borrowerFirstName, setBorrowerFirstName] = useState(null)
  const [borrowerLastName, setBorrowerLastName] = useState(null)
  const [borrowerFatherName, setBorrowerFatherName] = useState(null)
  const [borrowerEmail, setBorrowerEmail] = useState(null)
  const [borrowerPhone, setBorrowerPhone] = useState(null)
  const [borrowerAadhaar, setBorrowerAadhaar] = useState(null)
  const [borrowerAddress, setBorrowerAddress] = useState(null)
  const [borrowerCity, setBorrowerCity] = useState(null)
  const [borrowerState, setBorrowerState] = useState(null)
  const [purpose, setPurpose] = useState(null)
  const [borrowerPin, setBorrowerPin] = useState(null)
  const [borrowerPan, setBorrowerPan] = useState(null)
  const [borrowerDOB, setBorrowerDOB] = useState(null)
  const [isStudentApplicant, setIsStudentApplicant] = useState(false)

  const [employerName, setEmployerName] = useState(null)
  const [borrowerSalary, setBorrowerSalary] = useState(null)
  const [officeAddress, setOfficeAddress] = useState({})
  const [officePincode, setOfficePinCode] = useState(null)
  
  // ShowRoom Details
  const [showRoomId, setShowRoomId] = useState()
  const [showRoomName, setShowRoomName] = useState()
  const [showRoomMobile, setShowRoomMobile] = useState("")
  const [showRoomEmail, setShowRoomEmail] = useState("")
  const [showRoomAddress, setShowRoomAddress] = useState("")
  const [executiveId, setExecutiveId] = useState()
  const [executiveName, setExecutiveName] = useState()
  // Vehilce Details
  const [vType, setVType] = useState()
  const [vBrand, setVBrand] = useState()
  const [vModel, setVModel] = useState()
  // const [vColor, setVColor] = useState()
  const [vManufaturedDate, setVManufaturedDate] = useState()
  const [vInvoiceAmount, setVInvoiceAmount] = useState()
  const [vInsuranceAmount, setVInsuranceAmount] = useState()
  const [vRegistrationCharges, setVRegistrationCharges] = useState()
  const [vAccessoriesAmount, setVAccessoriesAmount] = useState()
  const [vLiveTax, setVliveTax] = useState()
  const [vOtherCharges, setVOtherCharges] = useState()
  const [vOnRoadPrice, setVOnRoadPrice] = useState()
  const [vDownPayment, setVDownPayment] = useState()
  // const [vROI, setVROI] = useState()
  // Nominee
  const [nomineeName, setNomineeName] = useState()
  const [nomineeDOB, setNomineeDOB] = useState()
  const [nomineeMobile, setNomineeMobile] = useState()
  const [relation, setRelation] = useState()

  const [otherDetails, setOtherDetails] = useState(null)
  const [customerInsuranceAmount, setCustomerInsuranceAmount] = useState(null)

  const [propertyType, setPropertyType] = useState(null)
  const [propertySize, setPropertySize] = useState(null)
  const [propertyAddress, setPropertyAddress] = useState(null)
  const [propertyDescription, setPropertyDescription] = useState(null)

  const [disableFields, setDisabledFields] = useState(false)
  const [address, setAddress] = useState({})
  const [sameAddress, setSameAddress] = useState(null)
  const [permanentPincode, setPermanentPinCode] = useState(null)
  const [currentPincode, setCurrentPinCode] = useState(null)
  const [showroomData, setShowRoomData] = useState([])
  const [executiveData, setExecutiveData] = useState([])

  const [mobileExists, setMobileExists] = useState(false);
  const checkMobileExists = async (mobile) => {
    const url =`/users/basic-info?searchField=${mobile}`
  if (mobile.length === 10) {
    try {
      const response = await axiosInstance.get(url, {
        headers: {
        },
      });
      
      if (response.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
        setMobileExists(true);
      } else {
        setMobileExists(false);
      }
    } catch (error) {
      console.error("Error checking mobile number:", error);
      setMobileExists(false);
    }
  } else {
    setMobileExists(false);
  }
};
  const handleDOBChange = (dob) => {
    setBorrowerDOB(dob);
    if (dob && loanType === 'Education Loan') {
      const birthYear = new Date(dob).getFullYear();
      const currentYear = new Date().getFullYear();
      const age = currentYear - birthYear;
      if (age < 21 || age > 59) {
        setErrors(prev => ({ ...prev, borrowerDOB: 'Age must be between 21 and 59 years' }));
      } else {
        setErrors(prev => ({ ...prev, borrowerDOB: '' }));
      }
    }
  };
  const [fileUploadCards, setFileUploadCards] = useState(
    loanType === 'Business Loan'
      ? newblFileCardTypes
      : loanType === 'Mortgage Loan'
        ? mlFileCardTypes
        : fileCardTypes
  );

  let [uploadedFilesArray, setUploadedFilesArray] = useState([])

  const [errors, setErrors] = useState({})
  const [panApiLimit, setPanApiLimit] = useState(1)

  const [open, setOpen] = useState(false)
  const [link, setLink] = useState("");
  const [passwordDialogFileId, setPasswordDialogFileId] = useState(null);

  const [openOtpConsent, setOpenOtpConsent] = useState(false);
  const handleCloseConsent = () => setOpen(false)

  const [aadhaarImageFrontUrl, setAadhaarImageFrontUrl] = useState(null);
  const [aadhaarImageBackUrl, setAadhaarImageBackUrl] = useState(null);
  const [panImageUrl, setPanImageUrl] = useState(null);
  const [entityType, setEntityType] = useState('');
  const [gstRegistered, setGstRegistered] = useState(false);
  // const [turnover, setTurnover] = useState(0); // 0: <₹3L, 1: ₹3L-₹30L, 2: >₹30L
  const [turnover, setTurnover] = useState(turnoverRanges[0].value);
  const [entityName, setEntityName] = useState(null)
  const [businessLoanAmount, setBusinessLoanAmount] = useState(200000); // 2L default
  const [businessLoanTenureMonth, setBusinessLoanTenureMonth] = useState(null);
  const [loanAmountError, setLoanAmountError] = useState('');
  const [gstNumber, setGstNumber] = useState(null)
  const [isLoadingApplicationCreation, setLoadingApplicationCreation] = useState(false)
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('error');
  const [toastDuration, setToastDuration] = useState(4000);

  const [leadType, setLeadType] = useState("direct");
  const [anchorName, setAnchorName] = useState("");

  // Securities Details (LAS)
  const [securitiesType, setSecuritiesType] = useState(null);
  const [securitiesIdNumber, setSecuritiesIdNumber] = useState(null);
  const [securitiesAmount, setSecuritiesAmount] = useState(null);

  const createdApplication = useSelector(
    (state) => state?.createApplication?.res
  );
  const createdBijayApplication = useSelector(
    (state) => state?.createBijayApplication?.res
  );
  const { userId: ctxUserId } = useSelector((state) => state.appContext);
  const validateEmail = email => {
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(email);
  };

  const handleEmploymentChange = (e) => {
    setEmployment(e.target.value)
  }

  const handleFiles = (newFile, documentType) => {
    setUploadedFile(newFile)
    setDocumentType(documentType)
    if (documentType === 'bank_statement3' || documentType === 'bank_statement6') {
      setPasswordDialogFileId(documentType)
      return
    }
  }
  useEffect(() => {
    if (uploadedFile && documentType) {
      if (documentType === 'bank_statement3' || documentType === 'bank_statement6') {
        return
      }
      handleFileUpload(documentType);
    }
  }, [uploadedFile, documentType]);

  useEffect(() => {
    if(loanType==="Vehicle Loan" && showroomData.length === 0  && executiveData.length === 0){
      const showroomUrl = `${process.env.REACT_APP_FINSTA_API_URL}/api/Loans/Transactions/GetShowrooms?Referaltype=${"F"}`
      const executiveUrl = `${process.env.REACT_APP_FINSTA_API_URL}/api/Loans/Transactions/GetBusinessExecutives?Designation=${"BUSINESS%20EXECUTIVE"}`
      fetchDetailsFromFinstaApi(showroomUrl, "showroom")
      fetchDetailsFromFinstaApi(executiveUrl, "executive")
    } 
  }, [loanType])

  useEffect(() => {
    const total =
      toNumber(vInvoiceAmount) +
      toNumber(vInsuranceAmount) +
      toNumber(vRegistrationCharges) +
      toNumber(vAccessoriesAmount) +
      toNumber(vLiveTax) +
      toNumber(vOtherCharges);

    setVOnRoadPrice(total);
  }, [
    vInvoiceAmount,
    vInsuranceAmount,
    vRegistrationCharges,
    vAccessoriesAmount,
    vLiveTax,
    vOtherCharges,
  ]);

  const handleFileUpload = async (documentType) => {
    if (loanType === 'Business Loan') {
      if (!entityName) {
        alert("please enter entity name before uploding documents")
        return;
      }
    }
    const urlUpload = '/file/upload'
    const uploadObj = new FormData()
    if (uploadObj) {
      uploadObj.append('file', uploadedFile)
      if (loanType === 'Business Loan') {
        if (documentType === "entity_gst" || documentType === "entity_pan" || documentType === "entity_registration") {
          uploadObj.append('type', `${documentType}_${entityName}`)
        } else {
          uploadObj.append('type', documentType)
        }
      } else {
        uploadObj.append('type', documentType)
      }

      try {

        const res = await axiosInstance.post(urlUpload, uploadObj)
        const obj = {
          userId: "",
          type: documentType === "aadhaar_back" || documentType === "aadhaar_front" ? "aadhaar" : documentType === "driving_license_back" || documentType === "driving_license_front" ? "driving_license" : documentType === "entity_gst" ? `entity_gst_${entityName}` : documentType === "entity_pan" ? `entity_pan_${entityName}` : documentType === "entity_registration"
            ? `entity_registration_${entityName}` : documentType,
          url1: documentType !== "aadhaar_back" && documentType !== "driving_license_back" ? res?.data?.data?.s3Url : "",
          url2: (documentType === "aadhaar_back" || documentType === "driving_license_back") ? res?.data?.data?.s3Url : "",
          documentId: 'string',
          documentType: res?.data?.data?.s3Url,
          documentPassword: filePassword,
          fileType: documentType,
          fileName: uploadedFile.name
        }

        setFileUploadCards(prev =>
          prev.map(item => item.id === documentType ? { ...item, disabled: true } : item)
        )

        if (uploadedFilesArray.length === 0) {
          setUploadedFilesArray([obj])
        }
        else {
          setUploadedFilesArray(old => [...old, obj])
        }
        setUploadedFile(null)
        setFilePassword(null)
      }
      catch (e) {
        alert('Network Error, Please reupload the file')
      }
    }

  }

  const getPinCodeAddress = async (pincode) => {
    const url = `/pincodes/pincode?pincode=${pincode}`;
    try {
      const response = await axiosInstance.get(url, {
      });

      if (response?.status === 200) {
        const data = { stateName: response?.data?.data?.stateName, districtName: response?.data?.data?.districtName }
        return data
      }
    } catch (error) {
      console.error("Error fetching address with pincode:", error);
    }
  }

  const getPermanentAddressWithPin = async (pincode) => {
    setBorrowerPin(pincode)
    if (pincode.length === 6) {
      const { stateName, districtName } = await getPinCodeAddress(pincode)
      setBorrowerCity(districtName);
      setBorrowerState(stateName);
      // setAddress({ ...address,permanentCity: districtName, permanentState: stateName}) 

      setAddress(prev => ({
        ...prev,
        permanentCity: districtName,
        permanentState: stateName
      }));

    }
  };

  const getCurrentAddressWithPin = async (pincode, type="") => {
    if (pincode.length === 6) {
      const { stateName, districtName } = await getPinCodeAddress(pincode)
      if(type==="office"){
        setOfficeAddress(prev => ({
          ...prev,
          officeCity: districtName, officeState: stateName
        }));
      }else{
        setAddress(prev => ({
          ...prev,
          currentCity: districtName, currentState: stateName
        }));
      }
    }

  };

  const handleDeleteFile = (fileType) => {
    const updatedFileUploadCards = fileUploadCards.map(item => item.id === fileType ? { ...item, disabled: false } : item)
    setFileUploadCards(updatedFileUploadCards)
    const finalFiles = uploadedFilesArray.filter(file => file.fileType !== fileType)
    setUploadedFilesArray(finalFiles)
  }
  const [tenures, setTenures] = useState([]);
  const [channelInstituteList, setChannelInstituteList] = useState([]);
  const [channelPartners, setChannelPartners] = useState([]);
  const getInstituteInfo = (text, tenure) => {
    // Handle tenures if provided
    if (tenure) {
      setTenures(tenure);
    }

    const trimmedText = typeof text === 'string' ? text.trim() : '';
    setInistuteName(trimmedText);

    if (!trimmedText || trimmedText.length < 4) {
      setInstituteList([]);
      setStarterPhrase("Type Institute Name");
      return;
    }

    // Special case for "Unlisted" - Case insensitive check
    if (trimmedText.toLowerCase() === "unlisted") {
      const unlistedInstitute = {
        label: "Unlisted",
        id: "606489ab-9639-4329-bfb4-265f20b86601",
        brandName: "Unlisted"
      };
      setInstituteList([unlistedInstitute]);
      setStarterPhrase("");
      setTenures(tenureOptions);
      // fetchProducts(unlistedInstitute.id);
      return;
    }

    // Promise array to keep track of all API calls
    const promises = [];

    // Always check channel partners if channelPartnerId exists
    if (decode?.channelPartnerId) {
      const getChannelInstitutes = `/institute/info/channelPartnerId?channelPartnerId=${decode?.channelPartnerId}`;
      const channelPromise = axiosInstance.get(getChannelInstitutes)
        .then((res) => {
          const channelInstitutes = res?.data?.data?.institutes || [];
          const channelInstitutesList = channelInstitutes.map((item) => ({
            label: item.brandName,
            id: item.id
          }));

          setChannelInstituteList(channelInstitutesList);

          if (channelInstitutes.length > 0) {
            const formattedData = channelInstitutes.map(item => ({
              label: item.brandName,
              id: item.id,
              ...item
            }));

            if (decode?.role === "channel_user") {
              const selectedInstitute = formattedData.find(
                (inst) => inst.brandName === decode.instituteName
              );

              if (selectedInstitute) {
                fetchProducts(selectedInstitute.id);
              }
            }

            return formattedData;
          }

          return [];
        })
        .catch((err) => {
          return [];
        });

      promises.push(channelPromise);
    }

    // Always search for institutes by name too
    const instituteInfoUrl = `/institute/info/name?name=${trimmedText}`;
    const institutePromise = axiosInstance
      .get(instituteInfoUrl, {
        headers: {
        },
      })
      .then((res) => {

        if (res.data.data && res.data.data.length > 0) {
          const formattedData = res.data.data.map(item => ({
            label: item.brandName,
            id: item.id,
            ...item
          }));

          if (decode?.role === "institute_user" || decode?.role === "institute_admin") {
            const selectedInstitute = formattedData.find(
              (inst) => inst.brandName === decode.instituteName
            );

            if (selectedInstitute && instituteName !== "Unlisted") {
              fetchProducts(selectedInstitute.id);
            }
          }

          return formattedData;
        }

        return [];
      })
      .catch((error) => {
        console.error("Error fetching institute info:", error);
        return [];
      });

    promises.push(institutePromise);

    // Process all results
    Promise.all(promises)
      .then((results) => {
        // Combine and deduplicate results based on institute ID
        const combinedResults = results.flat();

        // Add the Unlisted option if the search term matches
        if ("unlisted".includes(trimmedText.toLowerCase())) {
          combinedResults.push({
            label: "Unlisted",
            id: "606489ab-9639-4329-bfb4-265f20b86601",
            brandName: "Unlisted"
          });
        }

        const uniqueResults = [];
        const seenIds = new Set();

        for (const institute of combinedResults) {
          if (!seenIds.has(institute.id)) {
            uniqueResults.push(institute);
            seenIds.add(institute.id);
          }
        }

        if (uniqueResults.length === 0) {
          setInstituteList([]);
          setStarterPhrase("No institute Found");
        } else {
          setInstituteList(uniqueResults);
          setStarterPhrase("");
        }
      });
  };
  const getChannePartners = `/channel-partners/get-partners`
  useEffect(() => {
    axiosInstance.get(getChannePartners)
      .then((res) => {
        const channelPartners = res?.data?.data
        const channelPartnersList = channelPartners.map((item) => ({ label: item.beneficiaryName, id: item.partnerId }))
        const defaultPartner = channelPartnersList.find(partner => partner.id === decode?.channelPartnerId);
        setChannelPartners(channelPartnersList)
        setDefaultPartner(defaultPartner)
        if (decode?.role === "channel_user") {
          setPartnerId(decode?.channelPartnerId);
        }

      })
      .catch((errr) => {
      })
  }, [decode?.channelPartnerId, decode?.role]);
  const handlePartnerChange = (event, value) => {
    const selectedPartnerId = value?.id || null;
    setPartnerId(selectedPartnerId);
    setPartnerName(value?.label);
  };

  const fetchProducts = async (instituteId, instituteBrandName) => {
    try {
      const getprod = `/products/instituteId/active?instituteId=${instituteId}`;

      const response = await axiosInstance.get(getprod, {
        headers: {
        },
      });

      const uniqueProducts = response?.data?.data?.reduce((acc, item) => {
        if (!acc.some((product) => product.tenure === item.tenure)) acc.push(item);
        return acc;
      }, []);

      if (instituteBrandName === "Virohan Private Limited") {
        setTenures([...Array.from({ length: 10 }, (_, i) => ({ label: (i + 6).toString() })), { label: "27" }]);
      } else if (uniqueProducts.length > 0) {
        const sortedTenures = uniqueProducts
          .map((item) => ({ label: item.tenure.toString() }))
          .sort((a, b) => parseInt(a.label) - parseInt(b.label));
        setTenures(sortedTenures);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    if ((decode?.role === "institute_user" || decode?.role === "institute_admin") && decode?.instituteId) {
      fetchProducts(decode.instituteId, decode.instituteName);
    }
  }, [decode?.role, decode?.instituteId]);

  const handleStudentBorrower = (event) => {

    if (event.target.checked) {
      setIsStudentApplicant(true)
      setStudentFirstName(borrowerFirstName)
      setStudentLastName(borrowerLastName)
      setStudentPhone(borrowerPhone)
      setStudentEmail(borrowerEmail)
      setDisabledFields(true)
    }
    else {
      setIsStudentApplicant(false)
      setStudentFirstName(null)
      setStudentLastName(null)
      setStudentPhone(null)
      setStudentEmail(null)
      setDisabledFields(false)
    }



  }

  const getPanPro = () => {
    if (panApiLimit > 5) {
      alert("You've reached your maximum API call limit for PAN details. Try again later.")
      window.location.reload();
      return
    }

    const panProUrl = '/pan-pro'
    const panBody = {

      panNumber: borrowerPan,
      dateOfBirth: moment(borrowerDOB).format('DD/MM/YYYY')
    }

    if (getAge(borrowerDOB) <= 18) {
      window.alert("Check borrower age ! must be above 18 years old")
    }
    else {

      axiosInstance.post(panProUrl, panBody)
        .then((res) => {

          if (res?.data?.data?.pan_number) {
            if (decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
              createBijayApplications(res?.data?.data, uploadedFilesArray)
            }
            else {
              createApplications(res?.data?.data, uploadedFilesArray)

            }
            window.scrollTo(0, document.body.scrollHeight);

            // window.alert("Saved Details! Upload Documents Below.")

          }
          else {
            setPanApiLimit(prev => prev + 1)
            alert("Invalid PAN Details or Date of Birthss")
          }

        })
        .catch((err) => {
          alert("Invalid PAN Details or Date of Birth")
        })
    }
  }


  const defineBodyData = (panProDetails, uploadedArray) => {
    const get1 = uploadedArray
    const get2 = uploadedArray
    const get3 = uploadedArray
    const aadhaarUrl1 = get1?.filter(item => item.type === "aadhaar")[0]?.url1
    const aadhaarUrl2 = get2?.filter(item => item.type === "aadhaar")[0]?.url2
    const panUrl = get3?.filter(item => item.type === "pan")[0]?.url1
    let body = {
      // "ocrId": "string",
      mobile: borrowerPhone,
      instituteName: loanType,
      firstName:decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? panProDetails?.user_full_name_split[0] : borrowerFirstName,
      lastName: decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? panProDetails?.user_full_name_split[2] : borrowerLastName,
      fatherName: borrowerFatherName,
      // "studentName": "string",
      dateOfBirth: borrowerDOB,
      gender: panProDetails?.user_gender === "M" ? "Male" : "Female",
      isCoapplicant: false,
      // courseName: loanType,
      courseFees: courseFees,
      panId: borrowerPan.toUpperCase(),
      // panImage: panUrl,
      aadhaarId: panProDetails?.masked_aadhaar,
      // aadhaarFrontImage: aadhaarUrl1,
      // aadhaarBackImage: aadhaarUrl2,

      aadhaarFrontImage: aadhaarImageFrontUrl,
      aadhaarBackImage: aadhaarImageBackUrl,
      panImage: panImageUrl,
      employmentType: employment === "EMPLOYED" ? "salaried" : employment === "SELF_EMPLOYED" ? "self-employed" : "unemployed",
      employerName: employment === "EMPLOYED" ? employerName : "",
      salary: employment === "EMPLOYED" ? borrowerSalary : "",
      incomePerMonth: employment === "SELF_EMPLOYED" ? borrowerSalary : "",
      typeOfBusiness: employment === "SELF_EMPLOYED" ? employerName : "",
      email: borrowerEmail,
      currentAddress: address.currentAddress,
      currentCity: address.currentCity,
      currentState: address.currentState,
      currentPincode: currentPincode,
      loanTenure: loanType !== 'Education Loan' ? (Number(tenureYears) * 12) + Number(tenureMonths) : tenure,
      permanentAddress: address.permanentAddress,
      permanentCity: address.permanentCity,
      permanentState: address.permanentState,
      permanentPincode: permanentPincode,
      // "bankStatementS3": "string",
      // "productId": "string",
      // "accountNumber": "string",
      // "ifsc": "string",
      // beneficiaryName: borrowerFirstName + " " + borrowerLastName,

      // "propertyType": "string",
      // "propertyDescription": "string",
      // "propertyAddress": "string",
      // "propertySize": "string",
      // "otherDetails": "string",
      clientId: decode?.clientId,
      branchId: decode?.branchId,
      channelPartnerId: '',
      ...(decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && { customerInsuranceAmount: customerInsuranceAmount ? parseFloat(customerInsuranceAmount) : null }),
    };
    if (loanType === 'Consumer Loan') {
      body = { ...body, productType: Verticals.Consumer }
    }
    else if (loanType === 'Personal Loan') {
      body = { ...body, productType: Verticals.Personal }
    }
    else if (loanType === 'Vehicle Loan') {
      body = {
        ...body,
        productType: Verticals.Vehicle,
        subProductType: vType?.split(" - ")[1] === "Used"?  subVerticals[2]['Old']: subVerticals[2]['New'],
        officeAddress: officeAddress.officeAddress,
        officeCity: officeAddress.officeCity,
        officeState: officeAddress.officeState,
        officePincode,
        showRoomId,
        showRoomName,
        showRoomMobile,
        showRoomEmail,
        showRoomAddress,
        executiveId,
        executiveName,
        vehicleType: vType,
        vehicleBrandName: vBrand,
        vehicleModel: vModel,
        vehicleInsuranceFromDate: "",
        // vColor,
        vManufaturedDate,
        vInvoiceAmount,
        insuranceAmount: vInsuranceAmount,
        registrationCharges: vRegistrationCharges,
        accessoriesAmount: vAccessoriesAmount,
        liveTax: vLiveTax,
        otherCharges: vOtherCharges,
        vOnRoadPrice,
        vDownPayment,
        // vROI,
        // nomineeName,
        // nomineeDOB,
        // nomineeMobile,
        // nomineeRelation:relation,
        otherDetails: otherDetails,
      }
    }
    else if (loanType === 'Mortgage Loan') {
      let newAddress = {}
      if (decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
        newAddress = {
          currentAddress: borrowerAddress,
          currentCity: borrowerCity,
          currentState: borrowerState,
          currentPincode: borrowerPin,
          permanentAddress: '',
          permanentCity: '',
          permanentState: '',
          permanentPincode: '',
        }
      }
      body = {
        ...body,
        productType: Verticals.Mortgage,
        subProductType: subVerticals[3]['New'],
        propertyType: propertyType,
        propertySize: propertySize,
        propertyAddress: propertyAddress,
        propertyDescription: propertyDescription,
        otherDetails: otherDetails,
        ...newAddress
      }
    } else if (loanType === 'Loan Against Securities') {
      const newAddress = {
        currentAddress: borrowerAddress,
        currentCity: borrowerCity,
        currentState: borrowerState,
        currentPincode: borrowerPin,
        permanentAddress: '',
        permanentCity: '',
        permanentState: '',
        permanentPincode: '',
      }
      body = {
        ...body,
        productType: Verticals.LoanAgainstSecurities,
        securitiesType: securitiesType,
        securitiesIdNumber: securitiesIdNumber,
        securitiesAmount: securitiesAmount ? parseFloat(securitiesAmount) : null,
        otherDetails: otherDetails,
        ...newAddress,
      }
    } else if (loanType === 'Business Loan') {
      const selectedRange = turnoverRanges.find(r => r.value === turnover) || {};

      body = {
        mobile: borrowerPhone,
        instituteName: loanType,
        firstName: panProDetails?.user_full_name_split[0], // borrowerFirstName,
        lastName: panProDetails?.user_full_name_split[2], // borrowerLastName,
        dateOfBirth: borrowerDOB,
        gender: panProDetails?.user_gender === "M" ? "Male" : "Female",
        isCoapplicant: false,
        courseFees: businessLoanAmount,
        panId: borrowerPan.toUpperCase(),
        aadhaarId: panProDetails?.masked_aadhaar,
        aadhaarFrontImage: aadhaarImageFrontUrl,
        aadhaarBackImage: aadhaarImageBackUrl,
        panImage: panImageUrl,
        employmentType: "self-employed",
        employerName: "",
        salary: "",
        incomePerMonth: "",
        typeOfBusiness: entityName,
        email: borrowerEmail,
        currentAddress: borrowerAddress,
        currentCity: address.permanentCity,
        currentState: address.permanentState,
        currentPincode: borrowerPin,
        loanTenure: businessLoanTenureMonth,
        entityName: entityName,
        entityType: entityType,
        annualTurnoverRange: turnover,
        annualTurnoverLowerLimit: selectedRange.lowerLimit,
        annualTurnoverUpperLimit: selectedRange.upperLimit,
        gstRegistered: gstRegistered,
        gstNumber: gstRegistered ? gstNumber : "",
        leadType: leadType,
        leadName: leadType === "anchor" ? anchorName : "direct lead",
        productType: Verticals.Business,
        channel: decode?.role === "channel_user" ? 8 : 10,
        clientId: decode?.clientId,
        channelPartnerId: ''
      };
    }
    return body
  }

  const createBijayApplications = (panProDetails, uploadedArray) => {
    const body = defineBodyData(panProDetails, uploadedArray)
    const url = '/summary/create/admin'
    dispatch(userActions.createBijayApplication(url, body, user, uploadedArray))
    handleConsent()
  }

  const createApplications = async (panProDetails, uploadedArray) => {

    const get1 = uploadedArray
    const get2 = uploadedArray
    const get3 = uploadedArray
    const aadhaarUrl1 = get1?.filter(item => item.type === "aadhaar")[0]?.url1
    const aadhaarUrl2 = get2?.filter(item => item.type === "aadhaar")[0]?.url2
    const panUrl = get3?.filter(item => item.type === "pan")[0]?.url1

    const urlCreate = '/summary/create/admin'



    const body = {

      mobile: isStudentApplicant ? studentPhone : borrowerPhone,
      instituteName: loanType === 'Personal Loan' ? 'Personal Loan' : instituteName,
      firstName: isStudentApplicant ? studentFirstName : borrowerFirstName,
      lastName: isStudentApplicant ? studentLastName : borrowerLastName,
      studentName: `${studentFirstName} ${studentLastName}`,
      dateOfBirth: borrowerDOB,
      gender: panProDetails?.user_gender === "M" ? "Male" : "Female",
      isCoapplicant: false,
      courseName: loanType === 'Personal Loan' ? 'Personal Loan' : courseName,
      courseFees: courseFees,
      panId: borrowerPan.toUpperCase(),
      //  panImage: panUrl,
      aadhaarId: panProDetails?.masked_aadhaar,
      //  aadhaarFrontImage: aadhaarUrl1,
      //  aadhaarBackImage: aadhaarUrl2,
      aadhaarFrontImage: aadhaarImageFrontUrl,
      aadhaarBackImage: aadhaarImageBackUrl,
      panImage: panImageUrl,
      employmentType:
        employment === "EMPLOYED"
          ? "salaried"
          : employment === "SELF_EMPLOYED"
            ? "self-employed"
            : "unemployed",
      employerName: employment === "EMPLOYED" ? employerName : "",
      salary: employment === "EMPLOYED" ? borrowerSalary : "",
      incomePerMonth: employment === "SELF_EMPLOYED" ? borrowerSalary : "",
      typeOfBusiness: employment === "SELF_EMPLOYED" ? employerName : "",
      email: isStudentApplicant ? studentEmail : borrowerEmail,
      currentAddress: borrowerAddress,
      currentCity: borrowerCity,
      currentState: borrowerState,
      currentPincode: borrowerPin,
      loanTenure: loanType !== 'Education Loan' ? (Number(tenureYears) * 12) + Number(tenureMonths) : tenure,
      channel: decode?.role === "channel_user" ? 8 : 10,
      channelPartnerId: partnerId ? partnerId : decode?.role === "channel_user"
        ? decode?.channelPartnerId : "",
      productType: loanType === 'Personal Loan' ? Verticals.Personal : Verticals.Education,
      loanPurpose: purpose

    }
    const newBodyData = (loanType === 'Mortgage Loan' || loanType === 'Business Loan' || loanType === 'Loan Against Securities') ? defineBodyData(panProDetails, uploadedArray) : body
    setLoadingApplicationCreation(true)
    dispatch(userActions.createApplication(urlCreate, newBodyData, user, uploadedArray, decode?.instituteId))
    // handleConsent()

    //     setTimeout(() => {
    //   handleConsent();
    // }, 5000);
  }

  useEffect(() => {
    if (createdApplication?.userId && createdApplication?.applicationId) {
      setLoadingApplicationCreation(false)
      handleConsent();
    }
  }, [createdApplication]);

  const validateBusinessLoanFields = () => {
    const formErrors = {};

    if (!entityName) {
      formErrors.entityName = "Enter entity name";
    }
    if (!entityType) {
      formErrors.entityType = "Select entity type";
    }
    if (!turnover) {
      formErrors.turnover = "Select annual turnover";
    }
    // if (!gstRegistered) {
    //   formErrors.gstRegistered = "Select GST registration status";
    // }

    if (gstRegistered && !gstNumber) {
      formErrors.gstNumber = "Enter GST number";
    }

    if (leadType === "anchor" && !anchorName) {
      formErrors.anchorName = "Enter anchor name";
    }
    // else if (leadType === "direct" && !directName) {
    //   formErrors.directName = "Enter direct lead name";
    // }

    if (!businessLoanAmount || businessLoanAmount < 200000 || businessLoanAmount > 3000000) {
      formErrors.businessLoanAmount = "Enter loan amount between ₹2,00,000 and ₹30,00,000";
    }
    if (!businessLoanTenureMonth) {
      formErrors.businessLoanTenureMonth = "Select loan tenure";
    }
    if (!borrowerFirstName) {
      formErrors.borrowerFirstName = "Enter authorized signatory first name";
    }
    if (!borrowerLastName) {
      formErrors.borrowerLastName = "Enter authorized signatory last name";
    }
    if (!validateEmail(borrowerEmail)) {
      formErrors.borrowerEmail = "Enter a valid email";
    }
    if (!borrowerPhone || borrowerPhone.length !== 10) {
      formErrors.borrowerPhone = "Enter 10-digit phone";
    }
    if (!borrowerAadhaar || borrowerAadhaar.length !== 12) {
      formErrors.borrowerAadhaar = "Aadhaar must be 12 digits";
    }
    if (!borrowerPan || borrowerPan.length !== 10) {
      formErrors.borrowerPan = "Enter valid PAN";
    }
    if (!borrowerDOB) {
      formErrors.borrowerDOB = "Enter date of birth";
    } else if (getAge(borrowerDOB) < 18) {
      formErrors.borrowerDOB = "Borrower must be at least 18 years old";
    }
    if (!borrowerAddress) {
      formErrors.borrowerAddress = "Please enter address"
    }
    if (borrowerPin?.length !== 6) {
      formErrors.borrowerPin = "PIN must be 6 digits"

    }
    if (!borrowerCity) {
      formErrors.borrowerCity = "Please enter city"
    }
    if (!borrowerState) {
      formErrors.borrowerState = 'Please enter state'
    }
    if (gstRegistered) {
      if (!gstNumber) {
        formErrors.gstNumber = 'Please enter Gst Number'
      }
    }


    return formErrors;
  };

  const validateBusinessLoanFiles = () => {
    // const requiredFileIds = ['entity_pan', 'entity_registration'];
    const requiredFileIds = ['aadhaar_front', 'pan'];
    // if (gstRegistered) {
    //   requiredFileIds.push('entity_gst');
    // }
    const uploadedFileIds = uploadedFilesArray.map(file => file.fileType);

    const missingFiles = requiredFileIds.filter(id => !uploadedFileIds.includes(id));

    return missingFiles;
  };


  const validateFields = () => {
    let formErrors = {}

    if (loanType === 'Loan Against Securities') {
      if (!securitiesType) {
        formErrors.securitiesType = "Select security type";
      }
      if (!securitiesIdNumber || !securitiesIdNumber.trim()) {
        formErrors.securitiesIdNumber = "Enter security ID / reference number";
      }
      if (!securitiesAmount || Number(securitiesAmount) <= 0) {
        formErrors.securitiesAmount = "Enter security amount";
      }
    }

    if (loanType === 'Business Loan') {
      formErrors = validateBusinessLoanFields();
      setErrors(formErrors);

      const missingFiles = validateBusinessLoanFiles();
      if (missingFiles.length > 0) {
        alert(`Please upload required files:\n${missingFiles.join(', ')}`);
      }
      // alert(JSON.stringify(formErrors, null, 2));
      // return Object.keys(formErrors).length === 0;

      return Object.keys(formErrors).length === 0 && missingFiles.length === 0;
    }
    if (loanType === 'Education Loan') {
      if (!instituteName) {
        formErrors.instituteName = "Please enter institute name"

      }
      if (!studentFirstName) {
        formErrors.studentFirstName = "Enter student's first name"

      }
      if (!studentLastName) {
        formErrors.studentLastName = "Enter student's Last name"

      }
      if (!validateEmail(studentEmail)) {
        formErrors.studentEmail = "Please enter a valid email address"

      }
      if (studentPhone?.length !== 10) {
        formErrors.studentPhone = "Number must be 10 digits"

      }
      // if(!courseName){
      //   formErrors.courseName = "Please enter course name"

      // }
      if (!tenure) {
        formErrors.tenure = "Select loan tenure"
      }
    }
    if (loanType === "Vehicle Loan") {
      if(employment === 'EMPLOYED'){
        if (!officeAddress.officeAddress) formErrors.officeAddress = 'Enter address'
        if (!officePincode) formErrors.officePincode = 'PIN must be 6 digits'
        if (!officeAddress.officeCity) formErrors.officeCity = 'Enter city'
        if (!officeAddress.officeState) formErrors.officeState = 'Please enter state'
      }
      // Showroom Details
      if (!showRoomName) formErrors.showRoomName = "Enter showroom name";
      // if (showRoomMobile?.length !== 10) formErrors.showRoomMobile = "Number must be 10 digits";
      // if (!validateEmail(showRoomEmail)) formErrors.showRoomEmail = "Please enter a valid email address";
      // if (!showRoomAddress) formErrors.showRoomAddress = "Enter showroom address";
      if (!executiveName) formErrors.executiveName = "Enter executive name";
      // Vehicle Details
      if (!vType) formErrors.vType = "Select vehicle type";
      if (!vBrand) formErrors.vBrand = "Enter vehicle brand name";
      if (!vModel) formErrors.vModel = "Enter vehicle model";
      // if (!vColor) formErrors.vColor = "Enter vehicle color";
      if (!vManufaturedDate) formErrors.vManufaturedDate = "Enter manufacturing year";
      if (!vInvoiceAmount) formErrors.vInvoiceAmount = "Enter invoice amount";
      if (!vOnRoadPrice) formErrors.vOnRoadPrice = "Enter on-road price";
      if (!vDownPayment) formErrors.vDownPayment = "Enter down payment amount";
      if (!vInsuranceAmount) formErrors.vInsuranceAmount = "Enter insurance amount";
      if (!vRegistrationCharges) formErrors.vRegistrationCharges = "Enter registration charges";
      if (!vAccessoriesAmount) formErrors.vAccessoriesAmount = "Enter accessories amount";
      if (!vLiveTax) formErrors.vLiveTax = "Enter live tax";
      if (!vOtherCharges) formErrors.vOtherCharges = "Enter other charges";
      // if (!vROI) formErrors.vROI = "Enter ROI"; 
      // Nominee Details
      // if (!nomineeName) formErrors.nomineeName = "Enter nominee name";
      // if (!nomineeDOB) formErrors.nomineeDOB = "Enter nominee date of birth";
      // if (nomineeMobile?.length !== 10) formErrors.nomineeMobile = "Number must be 10 digits";
      // if (!relation) formErrors.relation = "Select relation with nominee";
    }

    if (loanType === 'Mortgage Loan') {
      if (!propertyType) {
        formErrors.propertyType = "Select Property Type"

      }
      if (!propertySize) {
        formErrors.propertySize = "Enter Property Size"

      }
      if (!propertyAddress) {
        formErrors.propertyAddress = "Enter Property Address"

      }
      if (!propertyDescription) {
        formErrors.propertyDescription = "Enter Property Description"

      }
    }
    if (!courseFees > 0) {
      formErrors.courseFees = `${decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Loan amount":"Course fees" } must be more than 0`

    }

    if (loanType !== 'Education Loan') {

      if ((!tenureYears && !tenureMonths) || ((Number(tenureYears || 0) * 12) + Number(tenureMonths || 0) === 0)) {
        formErrors.tenureMonths = (!tenureYears && !tenureMonths)
          ? "Select tenure"
          : "Select above 0";
      }



    }
    if (decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
      if (!borrowerFatherName) {
        formErrors.borrowerFatherName = 'Enter Borrower Father name'
      }
    }

    //Borrower details check

    if (!borrowerFirstName) {
      formErrors.borrowerFirstName = "Enter borrower's first name"

    }
    if (!borrowerLastName) {
      formErrors.borrowerLastName = "Enter borrower's last name"

    }
    if (!validateEmail(borrowerEmail) && decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
      formErrors.borrowerEmail = "Please enter a valid email address"

    }
    if (borrowerPhone?.length !== 10) {
      formErrors.borrowerPhone = "Number must be 10 digits"

    }
    if (borrowerAadhaar?.length !== 12) {
      formErrors.borrowerAadhaar = "Aadhaar must be 12 digits or masked"

    }
    if (borrowerPan?.length !== 10) {
      formErrors.borrowerPan = "Please enter a valid PAN"

    }
    if (!borrowerDOB) {
      formErrors.borrowerDOB = "Date of Birth is required";
    } else if (getAge(borrowerDOB) < 18) {
      formErrors.borrowerDOB = "Borrower must be at least 18 years old";
    }
    if (decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
      if (!borrowerAddress) {
        formErrors.borrowerAddress = "Please enter address"

      }
      if (borrowerPin?.length !== 6) {
        formErrors.borrowerPin = "PIN must be 6 digits"

      }
      if (!borrowerCity) {
        formErrors.borrowerCity = "Please enter city"

      }
      if (!borrowerState) {
        formErrors.borrowerState = 'Please enter state'

      }
    }

    if (loanType !== 'Mortgage Loan') {
      if (employment === 'EMPLOYED' || employment === 'SELF_EMPLOYED') {
        if (!employerName) {
          formErrors.employerName = "Enter employer name"

        }
        if (!borrowerSalary) {
          formErrors.borrowerSalary = "Please enter salary"

        }
      }
    }

    //Permanent & Current Address
    if (decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
      if (!address.permanentAddress) {
        formErrors.permanentAddress = 'Enter address'
      }
      if (!permanentPincode) {
        formErrors.permanentPincode = 'PIN must be 6 digits'
      }
      if (!address.permanentCity) {
        formErrors.permanentCity = 'Enter city'
      }
      if (!address.permanentState) {
        formErrors.permanentState = 'Please enter state'
      }
      if (!address.currentAddress) {
        formErrors.currentAddress = 'Enter address'
      }
      if (!currentPincode) {
        formErrors.currentPincode = 'PIN must be 6 digits'
      }
      if (!address.currentCity) {
        formErrors.currentCity = 'Enter city'
      }
      if (!address.currentState) {
        formErrors.currentState = 'Please enter state'
      }

    }


    setErrors(formErrors)
    // alert(JSON.stringify(formErrors,null,2))
    return Object.keys(formErrors).length === 0
  }

  const validateFiles = () => {
    return uploadedFilesArray.length > 0
  }

  // const handleStartSession = (panProDetails) => {
  //   const randomGen = Date.now().toString(36) + Math.random().toString(36).substr(2);
  //   window.getBureauSession(
  //     process.env.REACT_APP_PUBLIC_CONSENT_KEY,
  //     randomGen,
  //     `${panProDetails?.user_full_name_split[0]} ${panProDetails?.user_full_name_split[2]}`,
  //     "",
  //     "",
  //     borrowerPhone
  //   )
  //     .then((res) => {
  //       setOpen(true);
  //       setLink(res);
  //     });
  // };

  // const handleLoadSession = async () => {
  //   try {
  //     const result = await window.startBureauSession();
  //     if (result) {
  //       switch (result.status) {
  //         case "SUCCESS":
  //           try {
  //             let authToken = null;

  //             // Fetch the authToken
  //             const authResponse = await axiosInstance.post(`/login/auth`, {
  //               memberId: "9072e019-e159-4bdc-812a-bb3f255f4af0",
  //             });

  //             authToken = authResponse?.data?.data;

  //             if (!authToken) {
  //               throw new Error("Authentication token not received");
  //             }

  //             const userId = createdBijayApplication?.userId
  //             if (userId) {
  //               const data2 = {
  //                 userId,
  //                 latitude: 0,
  //                 longitude: 0,
  //                 doneBy: 'end-user'
  //               };

  //               // Second API call
  //               await axiosInstance.post('/end-user/submit/qec', data2, {
  //                 headers: {
  //                   Authorization: `Bearer ${authToken}`,
  //                   'Content-Type': 'application/json',
  //                 },
  //               });
  //               alert('Application Moved to In Review')
  //               handleCloseConsent()
  //               setTimeout(() => {
  //                 window.location.reload()
  //               }, 1000)
  //             }
  //           } catch (error) {
  //             console.error("Error during SUCCESS case:", error);
  //             alert("An error occurred while processing your request. Please try again.");
  //             handleCloseConsent()
  //             setTimeout(() => {
  //               window.location.reload()
  //             }, 1000)
  //           }
  //           break;

  //         case "EXIT":
  //           alert("Retry Submit");
  //           handleCloseConsent();
  //           break;

  //         case "ERROR":
  //           alert("Error Please Try Later");
  //           handleCloseConsent();
  //           break;

  //         default:
  //           alert("Contact our team for assistance");
  //           break;
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Unexpected error in handleLoadSession:", error);
  //     alert("An unexpected error occurred. Please try again later.");

  //   }
  // };

  const submitApplicationToInReview = async () => {
    try {
      let authToken = null;
      // Fetch the authToken
      const authResponse = await axiosInstance.post(`/login/auth`, {
        memberId: "8a403e17-1f9b-4857-88a1-1fcb9e9e18a4",
      });

      authToken = authResponse?.data?.data;

      if (!authToken) {
        throw new Error("Authentication token not received");
      }

      const userId = createdBijayApplication?.userId ?? createdApplication?.userId
      if (userId) {
        const data2 = {
          userId,
          latitude: 0,
          longitude: 0,
          doneBy: 'end-user'
        };

        // Second API call
        await axiosInstance.post('/end-user/submit/qec', data2, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        });
        showToast('Application Moved to In Review', 'success')
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    } catch (error) {
      alert("An error occurred while processing your request. Please try again.")
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    }
  };

  const showToast = (msg, type = 'error', duration = 4000) => {
    setToastMessage(msg);
    setToastType(type);
    setToastDuration(duration);
    setToastVisible(true);
  };

  useEffect(() => {
    const handler = (e) => showToast(e.detail.message, e.detail.type ?? 'success');
    window.addEventListener('feemonk-app-created', handler);
    return () => window.removeEventListener('feemonk-app-created', handler);
  }, []);

  useEffect(() => {
    if (mobileExists && decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
      showToast('User already exists with this mobile number', 'info', 0);
    }
  }, [mobileExists]);

  const handleSubmit = () => {
    if (validateFields()) {
      getPanPro()
    }
    else {
      showToast('Incomplete information given. Please check the details once.')
    }
  }

  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      setAddress({
        ...address,
        permanentAddress: address.permanentAddress || '',
        permanentCity: address.permanentCity || '',
        permanentState: address.permanentState || '',
        permanentPincode: address.permanentPincode || '',
        currentAddress: address.permanentAddress || '',
        currentCity: address.permanentCity || '',
        currentState: address.permanentState || '',
        currentPincode: permanentPincode,
      })
      setCurrentPinCode(permanentPincode)
    }
    else {
      setAddress({
        ...address,
        permanentAddress: address.permanentAddress,
        permanentCity: address.permanentCity || '',
        permanentState: address.permanentState || '',
        permanentPincode: address.permanentPincode || '',
        currentAddress: '',
        currentCity: '',
        currentState: '',
        currentPincode: '',
      })
      setCurrentPinCode(null)
    }
    setSameAddress(event.target.checked);
  };

  const channelInstituteChange = (value) => {
    setInistuteName(value?.label);
    fetchProducts(value.id);
  }

  const handleConsent = () => {
    setOpenOtpConsent(!openOtpConsent);

  }

  // OCR BEGIN

  const [ocrResponse, setOcrResponse] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleOCRStart = () => {
    setIsProcessing(true);
  };


  const addOcrReadAddressForBijay = (ocrData) => {
    if (!ocrData) return;
    const { address, city, state, pincode } = ocrData;
    const updatedAddress = {
      permanentAddress: address || "",
      permanentCity: city || "",
      // permanentState: state || "",
      permanentPincode: pincode || ""
    };
    setAddress(updatedAddress);
    // setCurrentPinCode(pincode || "");
    setPermanentPinCode(pincode || "");
    getPermanentAddressWithPin(pincode || "")

  }

  const updateBorrowerFromOCR = (ocrData) => {
    if (!ocrData) return;

    const {
      fullNamePerPan,
      fullNamePerAadhaar,
      aadhaarId,
      address,
      city,
      state,
      pincode,
      panId,
      dobPerPan,
      aadhaarImage1,
      aadhaarImage2,
      panImage
    } = ocrData;

    const selectedFullName =decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? fullNamePerAadhaar?.trim() || fullNamePerPan?.trim() || "" :  fullNamePerPan?.trim() || fullNamePerAadhaar?.trim() || "";

    const nameParts = selectedFullName.split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

    setBorrowerFirstName(firstName);
    setBorrowerLastName(lastName);
    setBorrowerFatherName(""); // You can extract from address if needed
    setBorrowerAadhaar(aadhaarId || "");
    setBorrowerAddress(address || "");
    setBorrowerCity(city || "");
    // setBorrowerState(state || "");
    setBorrowerPin(pincode || "");
    setBorrowerPan(panId || "");
    setBorrowerDOB(dobPerPan || "");
    setAadhaarImageFrontUrl(aadhaarImage1 || "");
    setAadhaarImageBackUrl(aadhaarImage2 || "");
    setPanImageUrl(panImage || "");


    // add address for bijay
    if (decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
      addOcrReadAddressForBijay(ocrData);
    } else {
      getPermanentAddressWithPin(pincode || "");
    }

  };


  const handleOCRSuccess = (response) => {
    setIsProcessing(false);
    setOcrResponse(response);
    updateBorrowerFromOCR(response)
    // alert("OCR Response:\n" + JSON.stringify(response, null, 2));

    // Now you can use the response data in your parent component
    // For example:
    // - Update form fields
    // - Store in state
    // - Make additional API calls
    // - Navigate to next step
  };

  const handleOCRError = (error) => {
    setIsProcessing(false);
    console.error('OCR Error:', error);
  };

  const fetchDetailsFromFinstaApi = async (url, type) => {
     try {
      const res = await axiosInstance(url)
      let resData;
      if(type==="showroom"){
        resData = res?.data?.referalMasterFirmDTO?.map(item => ({label: item?.vchagentname, ...item})) ?? []
        setShowRoomData(resData)
      }
      else{
        const resData = res?.data?.businessExecutiveDTOs?.map(item => ({label: item?.employeename,id:item?.employeeid, key:item?.employeeid, ...item})) ?? []
        setExecutiveData(resData)
      }
    
    } catch (e) {
    }
  }

  const setShowRoomDetails =(e, value) => {
    setShowRoomName(value?.label)
    setShowRoomId(value?.vchreferralid)
    setShowRoomMobile(value?.mobilenumber)
    setShowRoomEmail(value?.emailid)
    setShowRoomAddress(value?.address)
  }

  const toNumber = value => Number(value) || 0


  return (
    <>
      <Toast
        message={toastMessage}
        visible={toastVisible}
        onHide={() => { setToastVisible(false); setMobileExists(false); }}
        type={toastType}
        duration={toastDuration}
      />
      {loanType === 'Business Loan' ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, alignItems: 'stretch' }}>
          <Box className='fields-container' style={{ minHeight: '100%' }}>
            <h5 className='heading'>Loan details</h5>
            <Box sx={{ display: 'flex', flexDirection: { xs: "column", md: "row" }, alignItems: { xs: "center", md: "flex-end" }, justifyContent: 'space-evenly' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, backgroundColor: '#fbfeff97' }}>
                <Slider
                  value={businessLoanAmount}
                  min={200000}
                  max={3000000}
                  step={5000}
                  valueLabelDisplay="auto"
                  marks={[
                    { value: 200000, label: '2L' },
                    { value: 1000000, label: '10L' },
                    { value: 2000000, label: '20L' },
                    { value: 3000000, label: '30L' },
                  ]}
                  // onChange={(e, val) => setBusinessLoanAmount(val)}
                  onChange={(e, val) => {
                    setBusinessLoanAmount(val.toString());

                    // Clear error when value is valid
                    if (val >= 200000 && val <= 3000000) {
                      setLoanAmountError('');
                    }
                  }}
                  sx={{ mb: 3, width: 350, ml: 1, mt: 3 }}
                />

                <TextField
                  label="Loan Amount"
                  type="number"
                  size="small"
                  value={businessLoanAmount}
                  error={!!loanAmountError}
                  helperText={loanAmountError}

                  onKeyDown={(e) => {
                    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}

                  onChange={(e) => {
                    const val = e.target.value;

                    if (/^\d*$/.test(val)) {
                      setBusinessLoanAmount(val);

                      // Remove error only if value is within range and valid
                      const num = Number(val);
                      if (val && num >= 200000 && num <= 3000000) {
                        setLoanAmountError('');
                      }
                    } else {
                      setLoanAmountError('Please enter digits only');
                    }
                  }}
                  onBlur={(e) => {
                    const rawVal = e.target.value;
                    let val = Number(rawVal);

                    if (rawVal === '' || isNaN(val)) {
                      setLoanAmountError('Please enter a valid number');
                      return;
                    }

                    if (val < 200000) {
                      setLoanAmountError('Minimum allowed amount is ₹2,00,000');
                    } else if (val > 3000000) {
                      setLoanAmountError('Maximum allowed amount is ₹30,00,000');
                    } else {
                      setLoanAmountError('');
                    }
                  }}
                  sx={{ mb: 3, minWidth: 350 }}
                  inputProps={{
                    min: 200000,
                    max: 3000000,
                    step: 5000,
                  }}
                />


              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: 350 }}>
                <Typography sx={{ fontFamily: 'Outfit', fontWeight: 'bold', mr: 2 }}>Loan Tenure</Typography>
                <Autocomplete
                  sx={{ minWidth: 350 }}
                  options={businessLoanTenureMonthOptions}
                  size="small"
                  value={Number(businessLoanTenureMonth) || null}
                  onChange={(e, value) => setBusinessLoanTenureMonth(value?.value || null)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Months"
                      error={!!errors.businessLoanTenureMonth}
                      helperText={errors.businessLoanTenureMonth}
                      InputLabelProps={{
                        sx: {
                          fontFamily: 'Outfit',
                          bgcolor: "#fff8f4",
                          fontWeight: 'bold',
                          borderRadius: '5px',
                          fontSize: '14px',
                          lineHeight: '20.25px',
                          padding: '2px 8px 2px 8px',
                          color: '#000'
                        },
                      }}
                      sx={{
                        mb: 3,
                        "& label.Mui-focused": { color: "#000" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#707C8B" },
                          "&:hover fieldset": { borderColor: "#707C8B" },
                          "&.Mui-focused fieldset": { borderColor: "#707C8B" },
                          '& .MuiInputBase-input': { fontFamily: 'Outfit' },
                        },
                      }}
                    />
                  )}
                />
              </Box>
            </Box>
          </Box>

          {/* </Box> */}


        </Box>
      ) : (
        <OCRFileUpload
          onOCRStart={handleOCRStart}
          onOCRSuccess={handleOCRSuccess}
          onOCRError={handleOCRError}
        />
      )}

      {loanType === 'Business Loan' &&
        (<Box className='fields-container'>
          <h5 className='form-heading'>Entity Details</h5>

          <Box sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              md: "row",
            },
            justifyContent: "space-evenly",
            alignItems: {
              xs: "center",
              md: "flex-start",
            },
            gap: 2,
            minHeight: '40vh',
            flexWrap: 'wrap',
            width: "100%",
          }}>

            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', flexWrap: 'wrap' }} >
              <CustomTextField fullWidth label={'Entity Name'} id='Entity Name' value={entityName} error={!!errors.entityName} helperText={errors.entityName} handleTextFieldOnChange={(entName) => setEntityName(entName)} />

              <Autocomplete
                sx={{
                  width: '100%',
                  maxWidth: 350,
                  "& .MuiPopper-root": {
                    fontFamily: 'Outfit',
                    maxWidth: 350,
                    width: '100%',
                  },
                }}
                options={businessTypeEntityTypes}
                size="small"
                value={businessTypeEntityTypes.find(option => option.label === entityType) || null}
                onChange={(e, value) => setEntityType(value?.label || '')}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Entity Type"
                    error={!!errors.entityType}
                    helperText={errors.entityType}
                    InputLabelProps={{
                      sx: {
                        fontFamily: 'Outfit',
                        bgcolor: "#fff8f4",
                        fontWeight: 'bold',
                        borderRadius: '5px',
                        fontSize: '14px',
                        lineHeight: '20.25px',
                        padding: '2px 8px',
                        color: '#000',
                      },
                    }}
                    sx={{
                      mb: 3,
                      "& label.Mui-focused": {
                        color: "#000",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#707C8B",
                        },
                        "&:hover fieldset": {
                          borderColor: "#707C8B",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#707C8B",
                        },
                        '& .MuiInputBase-input': {
                          fontFamily: 'Outfit',
                        },
                      },
                    }}
                  />
                )}
              />

              {/* slider */}
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                <Typography sx={{ mb: 1, fontFamily: 'Outfit', fontWeight: 'bold' }}>
                  Annual Turnover
                </Typography>

                {/* Slider */}


                <Slider
                  value={turnoverRanges.findIndex(r => r.value === turnover)}
                  min={0}
                  max={turnoverRanges.length - 1}
                  step={1}
                  marks={turnoverRanges.map((r, idx) => ({ value: idx }))}
                  onChange={(e, idx) => setTurnover(turnoverRanges[idx].value)}
                  sx={{
                    ml: 4,
                    width: 280,
                    '& .MuiSlider-markLabel': {
                      fontSize: '10px', // smaller font
                      mt: '2px',
                      whiteSpace: 'nowrap',
                      minWidth: 0,
                      padding: 0,
                    },
                    '& .MuiSlider-mark': {
                      backgroundColor: '#000',
                      height: 12,
                      width: 2,
                      top: '50%',
                      transform: 'translateY(-50%)',
                    },
                    '& .MuiSlider-markActive': {
                      opacity: 1,
                    },
                  }}
                />

                <ButtonGroup variant="outlined" sx={{
                  mb: 2, mt: 2, '& .MuiButton-root': {
                    fontSize: '8px', // Decrease font size
                    // minWidth: 60,     // Make buttons more compact
                    // width: 70,
                    // px: 1,            // Reduce horizontal padding
                    // py: 0.5,          // Reduce vertical padding
                  },
                }}>
                  {turnoverRanges.map((range) => (
                    <Button
                      key={range.value}
                      size="small"
                      variant={turnover === range.value ? 'contained' : 'outlined'}
                      onClick={() => setTurnover(range.value)}
                    >
                      {range.label}
                    </Button>
                  ))}
                </ButtonGroup>


              </Box>

              {/* slider end */}


            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: "flex-start" }} >


              {/* new lead type begin */}
              <Box
                sx={{
                  minWidth: 280,
                  maxWidth: 400,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <FormControl
                  sx={{
                    mb: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <FormLabel
                    sx={{
                      fontFamily: "Outfit",
                      color: "#000000 !important",
                      fontWeight: "bold",
                      mb: 1,
                    }}
                  >
                    Lead Type
                  </FormLabel>

                  <RadioGroup
                    row
                    value={leadType}
                    onChange={(e) => setLeadType(e.target.value)}
                    sx={{
                      columnGap: 4,
                      "& .MuiFormControlLabel-label": {
                        color: "#000",
                      },
                    }}
                  >
                    <FormControlLabel value="direct" control={<Radio />} label="Direct Lead" />
                    <FormControlLabel value="anchor" control={<Radio />} label="Anchor Lead" />
                  </RadioGroup>
                </FormControl>

                {/* Conditional field based on selection */}
                {leadType === "anchor" && (
                  <CustomTextField
                    label="Anchor Name"
                    id="anchorName"
                    value={anchorName}
                    error={!!errors.anchorName}
                    helperText={errors.anchorName}
                    handleTextFieldOnChange={(val) => setAnchorName(val)}
                  />
                )}

              </Box>
              {/*  new lead type end */}

              {/* gst begin */}

              <Box
                sx={{
                  // flex: '1 1 300px',
                  // minWidth: 100,
                  // maxWidth: 400,
                  width: "100%",
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                }}
              >
                <FormControl sx={{
                  mb: 2, display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start', alignItems: 'flex-start'
                }}>
                  <FormLabel sx={{ fontFamily: 'Outfit', color: "#000000 !important", fontWeight: 'bold', mb: 1 }}>GST Registered</FormLabel>
                  <RadioGroup
                    row
                    // value={gstRegistered}
                    value={gstRegistered ? "yes" : "no"}
                    // onChange={(e) => setGstRegistered(e.target.value)}
                    onChange={(e) => setGstRegistered(e.target.value === "yes")}
                    sx={{
                      columnGap: 4,
                      '& .MuiFormControlLabel-label': {
                        color: '#000',
                      },
                    }}
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>

                {gstRegistered && (<Box sx={{ flex: 1, display: "block" }}>
                  <CustomTextField fullWidth label={'Gst Number'} id='Gst Number' value={gstNumber} error={!!errors.gstNumber} helperText={errors.gstNumber} handleTextFieldOnChange={(gstNum) => setGstNumber(gstNum)} />
                </Box>)}
              </Box>
              {/* gst end */}

            </Box>
          </Box>

        </Box>)

      }
      {/* end */}

      <Box className='fields-container'>
        {loanType === 'Business Loan' ? <h5 className='form-heading'>Authorized Signatory</h5> : <h5 className='form-heading'>Borrower Details</h5>}
        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }} >
          <CustomTextField label={'First Name'} id='borrowerFirstName' value={borrowerFirstName} error={!!errors.borrowerFirstName} helperText={errors.borrowerFirstName} handleTextFieldOnChange={(bftName) => setBorrowerFirstName(bftName)} />
          <CustomTextField label={'Last Name'} id='borrowerLastName' value={borrowerLastName} error={!!errors.borrowerLastName} helperText={errors.borrowerLastName} handleTextFieldOnChange={(bltName) => setBorrowerLastName(bltName)} />
          {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&
            <CustomTextField label={'Father Full Name'} id='fatherName' disabled={disableFields} value={borrowerFatherName} error={!!errors.borrowerFatherName} helperText={errors.borrowerFatherName} handleTextFieldOnChange={(bFaName) => setBorrowerFatherName(bFaName)} />
          }
          <CustomTextField label={'Phone'} type={'number'} id='borrowerPhone' value={borrowerPhone} error={!!errors.borrowerPhone} helperText={errors.borrowerPhone} handleTextFieldOnChange={(bPhone) => { setBorrowerPhone(bPhone); checkMobileExists(bPhone); }} />
          <CustomTextField label={'Email'} type={'email'} id='borrowerEmail' value={borrowerEmail} error={!!errors.borrowerEmail} helperText={errors.borrowerEmail} handleTextFieldOnChange={(bEmail) => { setBorrowerEmail(bEmail) }} />
          <CustomTextField label={'Aadhaar No'} type='text' value={borrowerAadhaar} error={!!errors.borrowerAadhaar} helperText={errors.borrowerAadhaar} handleTextFieldOnChange={(bAadhaar) => setBorrowerAadhaar(bAadhaar)} />
          <CustomTextField label={'PAN'} value={borrowerPan} error={!!errors.borrowerPan} helperText={errors.borrowerPan} handleTextFieldOnChange={(bPan) => setBorrowerPan(bPan.toUpperCase())} />
          <CustomTextField label='Date Of Birth' type='date' value={borrowerDOB} error={!!errors.borrowerDOB} helperText={errors.borrowerDOB} handleTextFieldOnChange={(dob) => handleDOBChange(dob)} />
          {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&
            <CustomTextField label={'Customer Insurance Amount + GST'} type='number' value={customerInsuranceAmount} handleTextFieldOnChange={(val) => setCustomerInsuranceAmount(val)} />
          }
          {!['Education Loan', 'Business Loan', 'Vehicle Loan'].includes(loanType) &&
            <>
              <CustomTextField label={'Loan Amount'} type='number' value={courseFees} error={!!errors.courseFees} helperText={errors.courseFees} handleTextFieldOnChange={(cFee) => setCourseFees(cFee)} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: 350 }}>
                <Typography sx={{ fontFamily: 'Outfit', fontWeight: 'bold' }}>Loan Tenure</Typography>
                <Autocomplete sx={{ "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={tenureYearMonthOptions} size='small' value={tenureYears}
                  onChange={(e, value) => setTenureYears(value?.label)}
                  renderInput={(params) => <TextField {...params} label="Years"
                    error={!!errors.tenureYears} helperText={errors.tenureYears}
                    InputLabelProps={{
                      sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                    }}

                    sx={{
                      minWidth: 120, mb: 3,
                      "& label.Mui-focused": {
                        color: "#000",

                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#707C8B",
                        },
                        "&:hover fieldset": {
                          borderColor: "#707C8B",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#707C8B",
                        },
                        '& .MuiInputBase-input': {
                          fontFamily: 'Outfit', // This applies the fontFamily to the input text
                        },
                      },
                    }}
                  />}
                />
                <Autocomplete sx={{ "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={tenureYearMonthOptions} size='small' value={tenureMonths}
                  onChange={(e, value) => setTenureMonths(value?.label)}
                  renderInput={(params) => <TextField {...params} label="Months"
                    error={!!errors.tenureMonths} helperText={errors.tenureMonths}
                    InputLabelProps={{
                      sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                    }}

                    sx={{
                      minWidth: 120, mb: 3,
                      "& label.Mui-focused": {
                        color: "#000",

                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#707C8B",
                        },
                        "&:hover fieldset": {
                          borderColor: "#707C8B",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#707C8B",
                        },
                        '& .MuiInputBase-input': {
                          fontFamily: 'Outfit', // This applies the fontFamily to the input text
                        },
                      },
                    }}
                  />}
                />
              </Box>
              {decode?.clientId === "d428c3d0-b5c7-4e9c-857b-e76c1cb8248c" ?
                <>
                  <Autocomplete sx={{
                    width: '100%',
                    maxWidth: 350,
                    "& .MuiPopper-root": {
                      fontFamily: 'Outfit', maxWidth: 350,
                      width: '100%'
                    }
                  }} options={PersonalLoanPurpose} size='small'
                    value={purpose}
                    onChange={(e, value) => setPurpose(value?.value)}
                    renderInput={(params) => <TextField {...params} label="Purpose of Loan"
                      error={!!errors.purpose} helperText={errors.purpose}
                      InputLabelProps={{
                        sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                      }}

                      sx={{

                        // minWidth: { xs: 150, md: 350 },

                        mb: 3,
                        "& label.Mui-focused": {
                          color: "#000",

                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#707C8B",
                          },
                          "&:hover fieldset": {
                            borderColor: "#707C8B",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#707C8B",
                          },
                          '& .MuiInputBase-input': {
                            fontFamily: 'Outfit', // This applies the fontFamily to the input text
                          },
                        },
                      }}
                    />}
                  />
                </> : null}

            </>
          }
          {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <>
            <CustomTextField label={'Address'} value={borrowerAddress} error={!!errors.borrowerAddress} helperText={errors.borrowerAddress} handleTextFieldOnChange={(bAddress) => setBorrowerAddress(bAddress)} />
            <CustomTextField label={'PIN Code'} type='number' value={borrowerPin} error={!!errors.borrowerPin} helperText={errors.borrowerPin} handleTextFieldOnChange={(bPin) => {
              getPermanentAddressWithPin(bPin)
            }
            } />
            <CustomTextField label={'City'} value={borrowerCity} error={!!errors.borrowerCity} helperText={errors.borrowerCity} handleTextFieldOnChange={(bCity) => setBorrowerCity(bCity)} />
            <Autocomplete sx={{
              width: '100%',
              maxWidth: 350,
              "& .MuiPopper-root": {
                fontFamily: 'Outfit', maxWidth: 350,
                width: '100%'
              }
            }} options={statesList} size='small'
              value={borrowerState}
              onChange={(e, value) => setBorrowerState(value?.label)}
              renderInput={(params) => <TextField {...params} label="State"
                error={!!errors.borrowerState} helperText={errors.borrowerState}
                InputLabelProps={{
                  sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                }}

                sx={{

                  // minWidth: { xs: 150, md: 350 },

                  mb: 3,
                  "& label.Mui-focused": {
                    color: "#000",

                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&:hover fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#707C8B",
                    },
                    '& .MuiInputBase-input': {
                      fontFamily: 'Outfit', // This applies the fontFamily to the input text
                    },
                  },
                }}
              />}
            />
          </>
          }
        </Box>
      </Box>

      {loanType === 'Education Loan' &&
        <Box className='fields-container'>
          <span style={{ display: 'flex', alignItems: 'center', fontFamily: 'Outfit', fontWeight: 'bold' }}>
            <Checkbox checked={isStudentApplicant} onChange={(e) => handleStudentBorrower(e)} id="studentBorrowerCheck" /> Is Student the borrower
          </span>
          <h5 className='form-heading'>Student Details</h5>
          <Box
            sx={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}

          >
            {decode?.role === "channel_user" ? (
              <>
                <CustomAutoComplete label={'Institute Name'} id='instituteName' value={decode?.role === "institute_user" || decode?.role === "institute_admin" ? decode?.instituteName : instituteName} error={!!errors.instituteName} disabled={decode?.role === "institute_user" || decode?.role === "institute_admin" ? true : false} helperText={errors.instituteName} noOptionsText={startingPhrase} options={instituteList} handleAutoCompleteChange={getInstituteInfo}
                  styles={{ width: '100%', maxWidth: 350 }} />

              </>
            ) : (
              <>
                <CustomAutoComplete label={'Institute Name'} id='instituteName' value={decode?.role === "institute_user" || decode?.role === "institute_admin" ? decode?.instituteName : instituteName} error={!!errors.instituteName} disabled={decode?.role === "institute_user" || decode?.role === "institute_admin" ? true : false} helperText={errors.instituteName} noOptionsText={startingPhrase} options={instituteList.length > 0 ? instituteList : [
                  ...(instituteName && instituteName.toLowerCase().includes('unlis') ?
                    [{
                      label: "Unlisted",
                      id: "606489ab-9639-4329-bfb4-265f20b86601",
                      brandName: "Unlisted"
                    }] : []
                  )
                ]} handleAutoCompleteChange={getInstituteInfo}
                  styles={{ width: '100%', maxWidth: 350 }} />
              </>
            )}
            <CustomTextField label={'First Name'} value={studentFirstName} disabled={disableFields} error={!!errors.studentFirstName} helperText={errors.studentFirstName} handleTextFieldOnChange={(stFtName) => setStudentFirstName(stFtName)} />
            <CustomTextField label={'Last Name'} value={studentLastName} disabled={disableFields} error={!!errors.studentLastName} helperText={errors.studentLastName} handleTextFieldOnChange={(stLtName) => setStudentLastName(stLtName)} />
            <CustomTextField label={'Mobile'} type='number' disabled={disableFields} value={studentPhone} error={!!errors.studentPhone} helperText={errors.studentPhone} handleTextFieldOnChange={(stPhone) => setStudentPhone(stPhone)} />
            <CustomTextField label={'Email'} type='email' disabled={disableFields} value={studentEmail} error={!!errors.studentEmail} helperText={errors.studentEmail} handleTextFieldOnChange={(stEmail) => { setStudentEmail(stEmail) }} />
            <CustomTextField label={'Course Name'} value={courseName} error={!!errors.courseName} helperText={errors.courseName} handleTextFieldOnChange={(cName) => setCourseName(cName)} />
            <CustomTextField label={'Course Fees'} type='number' value={courseFees} error={!!errors.courseFees} helperText={errors.courseFees} handleTextFieldOnChange={(cFee) => setCourseFees(cFee)} />
            <>
              <Autocomplete sx={{
                width: '100%',
                maxWidth: 350, "& .MuiPopper-root": {
                  fontFamily: 'Outfit', maxWidth: 350,
                  width: '100%'
                }
              }} options={tenures ? tenures : tenureOptions} size='small'
                onChange={(e, value) => setLoanTenure(value?.label)}
                renderInput={(params) => <TextField {...params} label="Loan Tenure"
                  error={!!errors.tenure} helperText={errors.tenure}
                  InputLabelProps={{
                    sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                  }}

                  sx={{
                    // minWidth:350, 
                    mb: 3,
                    "& label.Mui-focused": {
                      color: "#000",

                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#707C8B",
                      },
                      "&:hover fieldset": {
                        borderColor: "#707C8B",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#707C8B",
                      },
                      '& .MuiInputBase-input': {
                        fontFamily: 'Outfit', // This applies the fontFamily to the input text
                      },
                    },
                  }}
                />}
              />
            </>
          </Box>
          {/* <span style={{display:'flex', alignItems:'center', fontFamily:'Outfit', fontWeight:'bold'}}>
              <Checkbox checked={isStudentApplicant} onChange={(e) => handleStudentBorrower(e)}  id="studentBorrowerCheck"/> Is Student the borrower   
              </span> */}
        </Box>
      }

      {
        decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&
        <Box className='fields-container'>
          <h5 className='form-heading'>Permanent Address</h5>
          <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
            <CustomTextField label={'Address'} value={address.permanentAddress} error={!!errors.permanentAddress} helperText={errors.permanentAddress} handleTextFieldOnChange={(doNo) => setAddress({ ...address, permanentAddress: doNo })} />
            <CustomTextField label={'PIN Code'} type='number' value={permanentPincode} error={!!errors.permanentPincode} helperText={errors.permanentPincode} handleTextFieldOnChange={(pin) => {
              setPermanentPinCode(pin)
              getPermanentAddressWithPin(pin)
            }} />
            <CustomTextField label={'City'} value={address.permanentCity} error={!!errors.permanentCity} helperText={errors.permanentCity} handleTextFieldOnChange={(city) => setAddress({ ...address, permanentCity: city })} />
            <Autocomplete sx={{ width: '100%', maxWidth: 350,"& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={statesList} size='small'
              value={address.permanentState || null}
              onChange={(e, value) => setAddress({ ...address, permanentState: value?.label })}
              renderInput={(params) => <TextField {...params} label="State"
                error={!!errors.permanentCity} helperText={errors.permanentCity}
                InputLabelProps={{
                  sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                }}

                sx={{
                  maxWidth: 350, mb: 3,
                  "& label.Mui-focused": {
                    color: "#000",

                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&:hover fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#707C8B",
                    },
                    '& .MuiInputBase-input': {
                      fontFamily: 'Outfit', // This applies the fontFamily to the input text
                    },
                  },
                }}
              />}
            />
          </Box>
          <span style={{ display: 'flex', alignItems: 'center', fontFamily: 'Outfit', fontWeight: 'normal' }}>
            <Checkbox size='small' checked={sameAddress} onChange={(e) => handleCheckboxChange(e)} id="studentBorrowerCheck" />Is this your Current Address?
          </span>
          <h5 className='form-heading'>Current Address</h5>
          <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
            <CustomTextField label={'Address'} value={address.currentAddress} error={!!errors.currentAddress} helperText={errors.currentAddress} handleTextFieldOnChange={(doNo) => setAddress({ ...address, currentAddress: doNo })} />
            <CustomTextField label={'PIN Code'} type='number' value={currentPincode} error={!!errors.currentPincode} helperText={errors.currentPincode} handleTextFieldOnChange={(pin) => {
              setCurrentPinCode(pin)
              getCurrentAddressWithPin(pin)
            }} />
            <CustomTextField label={'City'} value={address.currentCity || null} error={!!errors.currentCity} helperText={errors.currentCity} handleTextFieldOnChange={(city) => setAddress({ ...address, currentCity: city })} />
            <Autocomplete sx={{width: '100%', maxWidth: 350, "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={statesList} size='small'
              value={address?.currentState || null}
              onChange={(e, value) => setAddress({ ...address, currentState: value?.label })}
              renderInput={(params) => <TextField {...params} label="State"
                error={!!errors.currentState} helperText={errors.currentState}
                InputLabelProps={{
                  sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                }}

                sx={{
                  maxWidth: 350, mb: 3,
                  "& label.Mui-focused": {
                    color: "#000",

                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&:hover fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#707C8B",
                    },
                    '& .MuiInputBase-input': {
                      fontFamily: 'Outfit', // This applies the fontFamily to the input text
                    },
                  },
                }}
              />}
            />
          </Box>


        </Box>
      }
      {loanType !== 'Business Loan' && <Box className='fields-container'>
        <h5 className='form-heading'>Employment</h5>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: -4, mb: 3 }}>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            row
            value={employment}
            onChange={handleEmploymentChange}
          >
            <FormControlLabel value="EMPLOYED" control={<Radio />} label="Salaried" sx={{ mr: 5, '& .MuiFormControlLabel-label': { fontFamily: 'Outfit', fontWeight: 'bold' } }} />
            <FormControlLabel value="SELF_EMPLOYED" control={<Radio />} label="Self Employed" sx={{ mr: 5, '& .MuiFormControlLabel-label': { fontFamily: 'Outfit', fontWeight: 'bold' } }} />
            <FormControlLabel value="UNEMPLOYED" control={<Radio />} label="Unemployed" sx={{ mr: 5, '& .MuiFormControlLabel-label': { fontFamily: 'Outfit', fontWeight: 'bold' } }} />
          </RadioGroup>
        </Box>
        {employment === 'EMPLOYED' && <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}
        >
          <CustomTextField label={'Employer Name'} value={employerName} error={!!errors.employerName} helperText={errors.employerName} handleTextFieldOnChange={(eName) => setEmployerName(eName)} />
          <CustomTextField label={'Salary'} type='number' value={borrowerSalary} error={!!errors.borrowerSalary} helperText={errors.borrowerSalary} handleTextFieldOnChange={(bSalary) => setBorrowerSalary(bSalary)} />
        </Box>}
        {employment === 'SELF_EMPLOYED' && <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}
        >
          <CustomTextField label={'Type of Business'} value={employerName} error={!!errors.employerName} helperText={errors.employerName} handleTextFieldOnChange={(eName) => setEmployerName(eName)} />
          <CustomTextField label={'Income Per Month'} type='number' value={borrowerSalary} error={!!errors.borrowerSalary} helperText={errors.borrowerSalary} handleTextFieldOnChange={(bSalary) => setBorrowerSalary(bSalary)} />
        </Box>}
        {loanType === 'Vehicle Loan' && employment === 'EMPLOYED'  &&
        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
          <CustomTextField label={'Office Address'} value={officeAddress.officeAddress} error={!!errors.officeAddress} helperText={errors.officeAddress} handleTextFieldOnChange={(doNo) => setOfficeAddress({ ...officeAddress, officeAddress: doNo })} />
          <CustomTextField label={'Office PIN Code'} type='number' value={officePincode} error={!!errors.officePincode} helperText={errors.officePincode} handleTextFieldOnChange={(pin) => {
            setOfficePinCode(pin)
            getCurrentAddressWithPin(pin, 'office')
          }} />
          <CustomTextField label={'Office City'} value={officeAddress.officeCity || null} error={!!errors.officeCity} helperText={errors.officeCity} handleTextFieldOnChange={(city) => setOfficeAddress({ ...officeAddress, officeCity: city })} />
          <Autocomplete sx={{width: '100%', maxWidth: 350, "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={statesList} size='small'
            value={officeAddress?.officeState || null}
            onChange={(e, value) => setOfficeAddress({ ...officeAddress, officeState: value?.label })}
            renderInput={(params) => <TextField {...params} label="Office State"
              error={!!errors.officeState} helperText={errors.officeState}
              InputLabelProps={{
                sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
              }}

              sx={{
                maxWidth: 350, mb: 3,
                "& label.Mui-focused": {
                  color: "#000",

                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&:hover fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#707C8B",
                  },
                  '& .MuiInputBase-input': {
                    fontFamily: 'Outfit',
                  },
                },
              }}
            />}
          />
          </Box>
        }
      </Box>}
      {loanType === 'Vehicle Loan' &&
      <Box className='fields-container'>
        <h5 className='form-heading'>ShowRoom Details</h5>
        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
          <Autocomplete freeSolo sx={{width: '100%', maxWidth: 350, "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={showroomData} size='small'
            value={showroomData.find(x => x.label === showRoomName) || null} 
            onChange={setShowRoomDetails}
            onInputChange={(e, value) => setShowRoomName(value)}
            renderInput={(params) => <TextField {...params} label="ShowRoom Name"
              error={!!errors.showRoomName} helperText={errors.showRoomName}
              InputLabelProps={{
                sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
              }}

              sx={{
                maxWidth: 350, mb: 3,
                "& label.Mui-focused": {
                  color: "#000",

                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&:hover fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#707C8B",
                  },
                  '& .MuiInputBase-input': {
                    fontFamily: 'Outfit', // This applies the fontFamily to the input text
                  },
                },
              }}
            />}
          />
          {/* <CustomAutoComplete label={'ShowRoom Name'} value={showRoomName} error={!!errors.showRoomName} helperText={errors.showRoomName} options={showroomData} handleAutoCompleteChange={(name) => setShowRoomDetails(name)} /> */}
          <CustomTextField label={'Mobile'} type='number' value={showRoomMobile} error={!!errors.showRoomMobile} helperText={errors.showRoomMobile} handleTextFieldOnChange={(mobile) => setShowRoomMobile(mobile)} />
          <CustomTextField label={'Email'} type={'email'} value={showRoomEmail} error={!!errors.showRoomEmail} helperText={errors.showRoomEmail} handleTextFieldOnChange={(email) => setShowRoomEmail(email)} />
          <CustomTextField label={'Address'} value={showRoomAddress} error={!!errors.showRoomAddress} helperText={errors.showRoomAddress} handleTextFieldOnChange={(address) => setShowRoomAddress(address)} />
          <Autocomplete freeSolo sx={{width: '100%', maxWidth: 350, "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={executiveData} size='small'
            value={executiveData.find(x => x.label === executiveName) || null} 
            onChange={(e, value) => {
              setExecutiveName(value?.label)
              setExecutiveId(value?.employeeid)
            }}
            getOptionKey={(option) => option?.employeeid}
            getOptionLabel={(option) => option?.label || ""}
            onInputChange={(e, value) => setExecutiveName(value)}
            renderInput={(params) => <TextField {...params} label="Executive Name"
              error={!!errors.executiveName} helperText={errors.executiveName}
              InputLabelProps={{
                sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
              }}

              sx={{
                maxWidth: 350, mb: 3,
                "& label.Mui-focused": {
                  color: "#000",

                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&:hover fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#707C8B",
                  },
                  '& .MuiInputBase-input': {
                    fontFamily: 'Outfit', // This applies the fontFamily to the input text
                  },
                },
              }}
            />}
          />
        </Box>
      </Box>
      }
      {loanType === 'Vehicle Loan' && <Box className='fields-container'>
        <h5 className='form-heading'>Vehicle Details</h5>

        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
          <Autocomplete sx={{width: '100%', maxWidth: 350, "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={vehicleTypeOptions} size='small'
            value={vType}
            onChange={(e, value) => setVType(value?.label)}
            renderInput={(params) => <TextField {...params} label="Vehicle Type"
              error={!!errors.vType} helperText={errors.vType}
              InputLabelProps={{
                sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
              }}

              sx={{
                maxWidth: 350, mb: 3,
                "& label.Mui-focused": {
                  color: "#000",

                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&:hover fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#707C8B",
                  },
                  '& .MuiInputBase-input': {
                    fontFamily: 'Outfit', // This applies the fontFamily to the input text
                  },
                },
              }}
            />}
          />
          <CustomTextField label={'Brand Name'} value={vBrand} error={!!errors.vBrand} helperText={errors.vBrand} handleTextFieldOnChange={(name) => setVBrand(name)} />
          <CustomTextField label={'Model'} value={vModel} error={!!errors.vModel} helperText={errors.vModel} handleTextFieldOnChange={(model) => setVModel(model)} />
          {/* <CustomTextField label={'Vehicle Color'} value={vColor} error={!!errors.vColor} helperText={errors.vColor} handleTextFieldOnChange={(color) => setVColor(color)} /> */}
          <CustomTextField label={'Year of Manufacture'}  type='number' value={vManufaturedDate} error={!!errors.vManufaturedDate} helperText={errors.vManufaturedDate} handleTextFieldOnChange={(date) => setVManufaturedDate(date)} />
          <CustomTextField label={'Loan Amount'} type='number' value={courseFees} error={!!errors.courseFees} helperText={errors.courseFees} handleTextFieldOnChange={
            (fee) =>{
             setCourseFees(fee)
            // setVDownPayment(vOnRoadPrice - fee)
            }}/>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: 350 }}>
            <Typography sx={{ fontFamily: 'Outfit', fontWeight: 'bold' }}>Loan Tenure</Typography>
            <Autocomplete sx={{ "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={tenureYearMonthOptions} size='small' value={tenureYears}
              onChange={(e, value) => setTenureYears(value?.label)}
              renderInput={(params) => <TextField {...params} label="Years"
                error={!!errors.tenureYears} helperText={errors.tenureYears}
                InputLabelProps={{
                  sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                }}

                sx={{
                  minWidth: 120, mb: 3,
                  "& label.Mui-focused": {
                    color: "#000",

                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&:hover fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#707C8B",
                    },
                    '& .MuiInputBase-input': {
                      fontFamily: 'Outfit', // This applies the fontFamily to the input text
                    },
                  },
                }}
              />}
            />
            <Autocomplete sx={{ "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={tenureYearMonthOptions} size='small' value={tenureMonths}
              onChange={(e, value) => setTenureMonths(value?.label)}
              renderInput={(params) => <TextField {...params} label="Months"
                error={!!errors.tenureMonths} helperText={errors.tenureMonths}
                InputLabelProps={{
                  sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
                }}

                sx={{
                  minWidth: 120, mb: 3,
                  "& label.Mui-focused": {
                    color: "#000",

                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&:hover fieldset": {
                      borderColor: "#707C8B",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#707C8B",
                    },
                    '& .MuiInputBase-input': {
                      fontFamily: 'Outfit', // This applies the fontFamily to the input text
                    },
                  },
                }}
              />}
            />
          </Box>
          <CustomTextField label={'Down Payment'} value={vDownPayment}  error={!!errors.vDownPayment} helperText={errors.vDownPayment} handleTextFieldOnChange={(amount)=> setVDownPayment(amount)} />
          <CustomTextField label={'Invoice Amount'}  type='number' value={vInvoiceAmount} error={!!errors.vInvoiceAmount} helperText={errors.vInvoiceAmount} handleTextFieldOnChange={(amount) => {
            setVInvoiceAmount(amount)
          }} />
          <CustomTextField label={'Insurance Amount'}  type='number' value={vInsuranceAmount} error={!!errors.vInsuranceAmount} helperText={errors.vInsuranceAmount} handleTextFieldOnChange={(amount) => setVInsuranceAmount(amount)} />
          <CustomTextField label={'Registration Charges'}  type='number' value={vRegistrationCharges} error={!!errors.vRegistrationCharges} helperText={errors.vRegistrationCharges} handleTextFieldOnChange={(amount) => setVRegistrationCharges(amount)} />
          <CustomTextField label={'Accessories Amount'}  type='number' value={vAccessoriesAmount} error={!!errors.vAccessoriesAmount} helperText={errors.vAccessoriesAmount} handleTextFieldOnChange={(amount) => setVAccessoriesAmount(amount)} />
          <CustomTextField label={'Live Tax'}  type='number' value={vLiveTax} error={!!errors.vLiveTax} helperText={errors.vLiveTax} handleTextFieldOnChange={(amount) => setVliveTax(amount)} />
          <CustomTextField label={'Other Charges'}  type='number' value={vOtherCharges} error={!!errors.vOtherCharges} helperText={errors.vOtherCharges} handleTextFieldOnChange={(amount) => setVOtherCharges(amount)} />
          <CustomTextField label={'On Road Price'}  type='number' value={vOnRoadPrice} error={!!errors.vOnRoadPrice} helperText={errors.vOnRoadPrice} handleTextFieldOnChange={(price) => setVOnRoadPrice(price)} />
          <CustomTextField label={'Other Details'} value={otherDetails} handleTextFieldOnChange={(details) => setOtherDetails(details)} />
        </Box>
      </Box>
      }
      {/* {loanType === 'Vehicle Loan' &&
      <Box className='fields-container'>
        <h5 className='form-heading'>Nominee Details</h5>
        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
          <CustomTextField label={'Name'}  value={nomineeName} error={!!errors.nomineeName} helperText={errors.nomi} handleTextFieldOnChange={(name) => setNomineeName(name)} />
          <CustomTextField label='Date Of Birth' type='date' value={nomineeDOB} error={!!errors.nomineeDOB} helperText={errors.nomine} handleTextFieldOnChange={(dob) => setNomineeDOB(dob)} />
          <CustomTextField label={'Mobile'}  type='number' value={nomineeMobile} error={!!errors.nomineeMobile} helperText={errors.nomineeMobile} handleTextFieldOnChange={(vModel) => setNomineeMobile(vModel)} />
          <Autocomplete sx={{width: '100%', maxWidth: 350, "& .MuiPopper-root": { fontFamily: 'Outfit', } }} options={relationOptions} size='small'
            value={relation}
            onChange={(e, value) => setRelation(value?.label)}
            renderInput={(params) => <TextField {...params} label="Relation"
              error={!!errors.relation} helperText={errors.relation}
              InputLabelProps={{
                sx: { fontFamily: 'Outfit', bgcolor: "#fff8f4", fontWeight: 'bold', borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px', padding: '2px 8px 2px 8px', color: '#000' },
              }}

              sx={{
                maxWidth: 350, mb: 3,
                "& label.Mui-focused": {
                  color: "#000",

                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&:hover fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#707C8B",
                  },
                  '& .MuiInputBase-input': {
                    fontFamily: 'Outfit', // This applies the fontFamily to the input text
                  },
                },
              }}
              />}
            />
        </Box>
      </Box>
      } */}
      {
        loanType === 'Mortgage Loan' && <Box className='fields-container'>
          <h5 className='form-heading'>Property Details</h5>
          <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
            <CustomAutoComplete label={'Property Type'} options={propertyTypeOptions} value={propertyType} error={!!errors.propertyType} helperText={errors.propertyType} handleAutoCompleteChange={(pType) => setPropertyType(pType)} />
            <CustomTextField label={'Property Size'} value={propertySize} error={!!errors.propertySize} helperText={errors.propertySize} handleTextFieldOnChange={(pSize) => setPropertySize(pSize)} />
            <CustomTextField label={'Address'} value={propertyAddress} error={!!errors.propertyAddress} helperText={errors.propertyAddress} handleTextFieldOnChange={(pAddress) => setPropertyAddress(pAddress)} />
            <CustomTextField label={'Property Description'} value={propertyDescription} error={!!errors.propertyDescription} helperText={errors.propertyDescription} handleTextFieldOnChange={(pDes) => setPropertyDescription(pDes)} />
            <CustomTextField label={'Other Remarks'} value={otherDetails} handleTextFieldOnChange={(details) => setOtherDetails(details)} />

          </Box>
        </Box>
      }
      {loanType === 'Loan Against Securities' && (
        <Box className='fields-container'>
          <h5 className='form-heading'>Securities Details</h5>
          <Box sx={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
            <Autocomplete
              sx={{
                width: '100%',
                maxWidth: 350,
                "& .MuiPopper-root": { fontFamily: 'Outfit', width: '100%', maxWidth: 350 },
              }}
              options={['Cheques', 'Bonds', 'Chits', 'Mutual Funds', 'Fixed Deposits', 'Insurance Policies', 'Shares', 'Other']}
              size='small'
              value={securitiesType}
              onChange={(e, value) => setSecuritiesType(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Security Type"
                  InputLabelProps={{
                    sx: {
                      fontFamily: 'Outfit', bgcolor: '#fff8f4', fontWeight: 'bold',
                      borderRadius: '5px', fontSize: '14px', lineHeight: '20.25px',
                      padding: '2px 8px', color: '#000',
                    },
                  }}
                  sx={{
                    width: '100%', maxWidth: 350, mb: 3,
                    '& label.Mui-focused': { color: '#000' },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: errors.securitiesType ? '#D32028' : '#707C8B' },
                      '&:hover fieldset': { borderColor: '#707C8B' },
                      '&.Mui-focused fieldset': { borderColor: '#707C8B' },
                      '& .MuiInputBase-input': { fontFamily: 'Outfit' },
                    },
                  }}
                  error={!!errors.securitiesType}
                  helperText={errors.securitiesType}
                />
              )}
            />
            <CustomTextField
              label='Security ID / Reference Number'
              id='securitiesIdNumber'
              value={securitiesIdNumber}
              error={!!errors.securitiesIdNumber}
              helperText={errors.securitiesIdNumber}
              handleTextFieldOnChange={(val) => setSecuritiesIdNumber(val)}
            />
            <CustomTextField
              label='Security Amount (₹)'
              id='securitiesAmount'
              type='number'
              value={securitiesAmount}
              error={!!errors.securitiesAmount}
              helperText={errors.securitiesAmount}
              handleTextFieldOnChange={(val) => setSecuritiesAmount(val)}
            />
            <CustomTextField
              label='Other Remarks'
              value={otherDetails}
              handleTextFieldOnChange={(val) => setOtherDetails(val)}
            />
          </Box>
        </Box>
      )}

      {(decode?.role !== ("institute_user" || "institute_admin") && decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') ? (<>
        {loanType !== 'Business Loan' && loanType !== 'Loan Against Securities' && <Box className='fields-container'>
          <h5 className='form-heading'>Partner Details (optional)</h5>
          <Box
            sx={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}

          >
            <Autocomplete
              sx={{
                width: '100%',
                maxWidth: 350,
                "& .MuiPopper-root": {
                  fontFamily: 'Outfit', width: '100%',
                  maxWidth: 350,
                }
              }}
              options={channelPartners}
              size='small'
              value={defaultPartner ? defaultPartner : partnerName}
              onChange={handlePartnerChange}
              disabled={decode?.role === "channel_user"} // Disable if user is channel_user
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Partner"
                  InputLabelProps={{
                    sx: {
                      fontFamily: 'Outfit',
                      bgcolor: "#fff8f4",
                      fontWeight: 'bold',
                      borderRadius: '5px',
                      fontSize: '14px',
                      lineHeight: '20.25px',
                      padding: '2px 8px 2px 8px',
                      color: '#000'
                    },
                  }}
                  sx={{
                    // minWidth: 350,
                    width: '100%',
                    maxWidth: 350,
                    mb: 3,
                    "& label.Mui-focused": {
                      color: "#000",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#707C8B",
                      },
                      "&:hover fieldset": {
                        borderColor: "#707C8B",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#707C8B",
                      },
                      '& .MuiInputBase-input': {
                        fontFamily: 'Outfit',
                      },
                    },
                  }}
                />
              )}
            />
            <input type="hidden" value={partnerId || ''} />


          </Box>
        </Box>}
      </>) : null}

      {loanType !== 'Business Loan' && (<Box className='fields-container'>
        <h5 className='form-heading'>File Uploads</h5>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', padding: '10px 10px 10px 10px' }}>
          {
            fileUploadCards.map((fileCard, index) => {
              return (
                <Box key={fileCard?.id}>
                  <InputFileUpload key={fileCard?.id} image={fileCard.image} label={fileCard.label} id={fileCard.id} handleFiles={handleFiles} disabled={fileCard.disabled} />
                  {/* Statemet Pdf Password */}
                  {
                    (fileCard?.id === 'bank_statement3' || fileCard?.id === 'bank_statement6') && passwordDialogFileId === fileCard?.id && (
                      <Dialog key={fileCard?.id} open={true} fullWidth >
                        <Box sx={{ p: 2, }}>
                          <Typography sx={{ fontSize: 18, fontFamily: 'Outfit', fontWeight: 'bold' }}>Enter Password if any?</Typography>
                          <CustomTextField label='Enter Password' value={filePassword} styles={{ mt: 1 }} handleTextFieldOnChange={(password) => setFilePassword(password)} />
                          <DialogActions sx={{ gap: 2 }}>
                            <Button size='small' onClick={() => setPasswordDialogFileId(null)} sx={{ color: '#D32028', fontFamily: 'Outfit', }}>Cancel</Button>
                            <Button size='small' sx={{ color: '#D32028', borderColor: '#D32028', fontFamily: 'Outfit', }}
                              variant='outlined' onClick={() => {
                                handleFileUpload(fileCard?.id)
                                setPasswordDialogFileId(null);
                              }} >
                              Continue
                            </Button>
                          </DialogActions>
                        </Box>
                      </Dialog>)
                  }
                </Box>
              )
            })
          }
        </Box>
        {uploadedFilesArray.length > 0 &&
          <Box className='files-container'>
            <p className='file-count'>{`${uploadedFilesArray?.length} Files uploaded`}</p>
            {uploadedFilesArray.map((file, index) => <Box className='file-card' key={index}>
              <p>{`${file?.fileType} (${file?.fileName}) - uploaded`}</p>
              <DeleteIcon fontSize='small' onClick={() => handleDeleteFile(file?.fileType)} sx={{ cursor: 'pointer', m: 0 }} />
            </Box>)}
          </Box>
        }

      </Box>)}

      {/* authorized signatory files uploads */}
      {loanType === 'Business Loan' && (<Box className='fields-container'>
        <h5 className='form-heading'>Authorized Signatory File Uploads</h5>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', padding: '10px 10px 10px 10px' }}>
          {
            fileUploadCards.map((fileCard, index) => {
              return (
                <Box key={fileCard?.id}>
                  <InputFileUpload key={fileCard?.id} image={fileCard.image} label={fileCard.label} id={fileCard.id} handleFiles={handleFiles} disabled={fileCard.disabled} />
                  {/* Statemet Pdf Password */}
                  {
                    (fileCard?.id === 'bank_statement3' || fileCard?.id === 'bank_statement6') && passwordDialogFileId === fileCard?.id && (
                      <Dialog key={fileCard?.id} open={true} fullWidth >
                        <Box sx={{ p: 2, }}>
                          <Typography sx={{ fontSize: 18, fontFamily: 'Outfit', fontWeight: 'bold' }}>Enter Password if any?</Typography>
                          <CustomTextField label='Enter Password' value={filePassword} styles={{ mt: 1 }} handleTextFieldOnChange={(password) => setFilePassword(password)} />
                          <DialogActions sx={{ gap: 2 }}>
                            <Button size='small' onClick={() => setPasswordDialogFileId(null)} sx={{ color: '#D32028', fontFamily: 'Outfit', }}>Cancel</Button>
                            <Button size='small' sx={{ color: '#D32028', borderColor: '#D32028', fontFamily: 'Outfit', }}
                              variant='outlined' onClick={() => {
                                handleFileUpload(fileCard?.id)
                                setPasswordDialogFileId(null);
                              }} >
                              Continue
                            </Button>
                          </DialogActions>
                        </Box>
                      </Dialog>)
                  }
                </Box>
              )
            })
          }
        </Box>
        {uploadedFilesArray.length > 0 &&
          <Box className='files-container'>
            <p className='file-count'>{`${uploadedFilesArray?.length} Files uploaded`}</p>
            {uploadedFilesArray.map((file, index) => <Box className='file-card' key={index}>
              <p>{`${file?.fileType} (${file?.fileName}) - uploaded`}</p>
              <DeleteIcon fontSize='small' onClick={() => handleDeleteFile(file?.fileType)} sx={{ cursor: 'pointer', m: 0 }} />
            </Box>)}
          </Box>
        }

      </Box>)}

      {/* end */}

      <OtpConsent openOtpConsent={openOtpConsent} submitApplicationToInReview={submitApplicationToInReview} handleConsent={handleConsent} mobile={borrowerPhone} />
      <Button className="submit-button" onClick={handleSubmit}>Submit</Button>
      {/* <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        keepMounted
        closeAfterTransition
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <Box
            style={{ backgroundColor: "white" }}
            sx={{
              width: "500px",
              maxWidth: "90vw",
              borderRadius: "8px",
              boxShadow: 24,
              p: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: "500",
                  fontSize: "20px",
                }}
              >
                OTP Consent
              </Typography>
              <IconButton
                sx={{
                  border: "2px solid #DbDbDb",
                }}
                aria-label="close"
                size="small"
                onClick={handleCloseConsent}
              >
                <ClearIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <iframe
                width="100%"
                height="630px"
                src={link}
                onLoad={handleLoadSession}
                title="bureau"
                style={{
                  border: "none",
                  borderRadius: "4px",
                }}
              ></iframe>
            </Box>
          </Box>
        </Box>
      </Modal> */}

      <OCRLoadingModal
        // isLoading={true}
        isLoading={isLoadingApplicationCreation}
        spinnerText="Processing"
        text="Your application is being created. Please hold on..."

      />

    </>

  )
}
